import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { StaticPage } from './static.page';

const routes: Routes = [
  /* TODO: This is how it should be: */
  // {
  //   path: '',
  //   component: StaticPage,
  //   children: [
  //     {
  //       path: 'landing',
  //       loadChildren: () => import('./pages/landing/landing.module').then( m => m.LandingPageModule)
  //     },
  //     {
  //       path: 'login',
  //       loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  //     },
  //     {
  //       path: 'signup',
  //       loadChildren: () => import('./pages/signup/signup.module').then( m => m.SignupPageModule)
  //     },
  //     {
  //       path: 'forgot-password',
  //       loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
  //     }
  //   ]
  // }
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
   {
    path: 'login',
    component: StaticPage,
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
      },
      {
        path: 'signup',
        loadChildren: () => import('./pages/signup/signup.module').then( m => m.SignupPageModule)
      },
      {
        path: 'forgot-password',
        loadChildren: () => import('./pages/forgot-password/forgot-password.module').then( m => m.ForgotPasswordPageModule)
      }
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StaticPageRoutingModule {}
